import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useLegalForms } from '@/hooks/useLegalForms';

interface LegalFormSelectProps {
  countryCode?: string | null;
  value?: string | null;
  onValueChange: (value: string) => void;
  disabled?: boolean;
}

export function LegalFormSelect({ countryCode, value, onValueChange, disabled }: LegalFormSelectProps) {
  const { data: legalForms, isLoading } = useLegalForms(countryCode);

  if (!countryCode) {
    return (
      <Select disabled>
        <SelectTrigger>
          <SelectValue placeholder="Select a country first" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="_none" disabled>Select a country first</SelectItem>
        </SelectContent>
      </Select>
    );
  }

  return (
    <Select
      value={value ?? ""}
      onValueChange={onValueChange}
      disabled={disabled || isLoading}
    >
      <SelectTrigger>
        <SelectValue placeholder={isLoading ? 'Loading...' : 'Select legal form'} />
      </SelectTrigger>
      <SelectContent>
        {(legalForms ?? []).map((lf) => (
          <SelectItem key={lf.id} value={lf.id}>
            {lf.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
